/* eslint-disable no-underscore-dangle */
import React from 'react';
import ReactDOM from 'react-dom';

// Globals
import './utils/globals.css';

// Jquery to bootstrap/slick
import 'jquery/dist/jquery.min';
// Bootstrap
import 'bootstrap/dist/js/bootstrap.min';
// Datepciker
// import "react-datepicker/dist/react-datepicker.css";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

// ReactSlick
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './configStore';

import App from './App';


ReactDOM.render(
  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistor}> */}
    <App />
    {/* </PersistGate> */}
  </Provider>,
  document.getElementById('root'),
);
